import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Avatar, Tooltip, Typography, useTheme, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { Link } from "react-router-dom";
import ShiftTimeLine from "./ShiftTimeLine";
import { useSelector } from "react-redux";
import { TimelapseOutlined, DeleteForeverOutlined } from "@mui/icons-material";
import { CalendarIcon } from "@mui/x-date-pickers";

export default function MobileShiftBox(props) {
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const fullData = { employeeDetail: props.employee, email: props.email };
  const { schedule } = props.shift;
  const [startvalue, setStartValue] = useState(new Date(props.shift.startDate));
  const [endvalue, setEndValue] = useState(
    !props.shift.endDate ? new Date() : new Date(props.shift.endDate)
  );
  const [startTime, setStartTime] = useState(props.shift.startDate);
  const [endTime, setEndTime] = useState(props.shift.endDate);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [breakTime, setBrakeTime] = useState(
    Array.isArray(props.shift.break) ? props.shift.break : []
  );
  const [shiftApproved, setShiftApproved] = useState(props.shift.approved);
  const [shiftLength, setShiftLength] = useState(props.shift.totalShiftLength);
  const [totalBreak, setTotalBreak] = useState(props.shift.totalBreak);
  const [shiftWOBreak, setShiftWOBreak] = useState(
    props.shift.shiftWithoutBreak
  );

  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isVerySmall = useMediaQuery('(max-width:360px)');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // function to add break in the break array
  const addBreak = () => {
    const newArray = [...breakTime];
    newArray.push({ start: new Date(), end: new Date() });
    setBrakeTime(newArray);
    newArray.map((i) => {
      setTotalBreak(totalBreak + calculateBreakLength(i.start, i.end));
    });
  };

  function convertS3ToCloudFront(url) {
    // Replace the AWS S3 domain with the CloudFront domain
    const cloudFrontDomain = 'https://d2k8ghk99lpcqm.cloudfront.net/';
    const s3Domain = 'https://cms-shifts.s3.ap-southeast-2.amazonaws.com/';

    // Check if the URL starts with the S3 domain
    if (url && url.startsWith(s3Domain)) {
      // Replace the S3 domain with the CloudFront domain
      const convertedUrl = url.replace(s3Domain, cloudFrontDomain);
      return convertedUrl;
    } else {
      // URL doesn't match the expected pattern
      console.error('Invalid URL format');
      return url;
    }
  }

  const getAvatarName = (employee) => {
    if (employee.employeeDetail) {
      if (employee.employeeDetail.fname && employee.employeeDetail.lname) {
        return employee.employeeDetail.fname.charAt(0).toUpperCase() + employee.employeeDetail.lname.charAt(0).toUpperCase();
      }
      else if (employee.employeeDetail.fname) {
        return employee.employeeDetail.fname.charAt(0).toUpperCase();
      }
      else if (employee.employeeDetail.lname) {
        return employee.employeeDetail.lname.charAt(0).toUpperCase();
      }
    }
    else {
      return employee.email.charAt(0).toUpperCase();
    }
  };

  // function to update the start time for particular break in the break array
  const updateStartBreak = (value, index) => {
    const newArray = [...breakTime];
    newArray[index]["start"] = value;
  };

  // function to update the end time for particular break in the break array
  const updateEndBreak = (value, index) => {
    const newArray = [...breakTime];
    newArray[index]["end"] = value;
  };

  // function to remove break from the break array
  const removeBreak = (index) => {
    const newArray = [...breakTime];
    newArray.splice(index, 1);
    setBrakeTime(newArray);
  };

  // function to format dates for making them usable
  const formatTime = (date) => {
    const d = new Date(date);
    return d.toLocaleTimeString("en-GB");
  };

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // Submit handler for sending an update request
  const submitHandler = () => {
    const config = {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${userInfo.JWT_TOKEN}`,
      },
    };

    axios
      .patch(
        `${process.env.REACT_APP_API_BACKEND}/api/employee/shiftedit/${props.shift.id}`,
        {
          startDate: startvalue,
          endDate: endvalue,
          break: breakTime,
          approved: shiftApproved,
          totalShiftLength: shiftLength,
          totalBreak: totalBreak,
          shiftWithoutBreak: shiftWOBreak,
        },
        config
      )
      .then((res) => {
        props.setSuccess(res.data.message);
        setStartTime(startvalue);
        setEndTime(endvalue);
        handleClose();
      })
      .catch((err) => {
        console.log(err.response.data.message);
        handleClose();
        props.setError(err.response.data.message);
      });
  };

  const handleEndShift = () => {
    const config = {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${userInfo.JWT_TOKEN}`,
      },
    };
    axios
      .patch(
        `${process.env.REACT_APP_API_BACKEND}/api/employee/shiftend/${props.shift.id}`, {}, config
      )
      .then((res) => {
        props.setSuccess(res.data.message);
        props.fetchShifts();
        handleClose();
      })
      .catch((err) => {
        console.log(err.response.data.message);
        handleClose();
        props.setError(err.response.data.message);
      });
  };

  // function to toggle shift between approved and unapproved
  const handleShiftApproved = () => {
    if (shiftApproved == true) {
      setShiftApproved(false);
    } else {
      setShiftApproved(true);
    }
  };
  
  // function to approve and update shift
  const approveAndUpdate = () => {
    const config = {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${userInfo.JWT_TOKEN}`,
      },
    };

    axios
      .patch(
        `${process.env.REACT_APP_API_BACKEND}/api/employee/shiftapprove/${props.shift.id}`,
        {},
        config
      )
      .then((res) => {
        props.setSuccess(res.data.message);
        setShiftApproved(true);
        handleClose();
      })
      .catch((err) => {
        console.log(err.response.data.message);
        handleClose();
        props.setError(err.response.data.message);
      });
  };

  function calculateBreakLength(start, end) {
    let now = new Date(start);
    let endDate = new Date(end);
    let diff = Math.abs(endDate - now);

    let hours = Math.floor(diff / 3.6e6);
    let minutes = Math.floor((diff % 3.6e6) / 6e4);
    let total;
    if (hours < 10) {
      if (minutes < 10) {
        total = "0" + hours + ":0" + minutes;
      } else {
        total = "0" + hours + ":" + minutes;
      }
    } else {
      if (minutes < 10) {
        total = hours + ":0" + minutes;
      } else {
        total = hours + ":" + minutes;
      }
    }
    return total;
  }

  function calculateTotalBreak() {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    breakTime.map((brk) => {
      let now = new Date(brk.start);
      let endDate = brk.end ? new Date(brk.end) : new Date();
      let diff = Math.abs(endDate - now);

      hours = hours + Math.floor(diff / 3.6e6);
      minutes = minutes + Math.floor((diff % 3.6e6) / 6e4);
      if (minutes > 59) {
        minutes = minutes - 60;
        hours = hours + 1;
      }
      seconds = seconds + Math.round(Math.floor((diff % 6e4) / 1000));
    });
    let total;
    if (hours < 10) {
      if (minutes < 10) {
        if (seconds < 10) {
          total = "0" + hours + ":0" + minutes + ":0" + seconds;
        } else {
          total = "0" + hours + ":0" + minutes + ":" + seconds;
        }
      } else {
        if (seconds < 10) {
          total = "0" + hours + ":" + minutes + ":0" + seconds;
        } else {
          total = "0" + hours + ":" + minutes + ":" + seconds;
        }
      }
    } else {
      if (minutes < 10) {
        if (seconds < 10) {
          total = hours + ":0" + minutes + ":0" + seconds;
        } else {
          total = hours + ":0" + minutes + ":" + seconds;
        }
      } else {
        if (seconds < 10) {
          total = hours + ":" + minutes + ":0" + seconds;
        } else {
          total = hours + ":" + minutes + ":" + seconds;
        }
      }
    }

    setTotalBreak(total);
  }

  function calculateTotalShiftLength() {
    let now = new Date(startvalue);
    let endDate = new Date(endvalue);
    let diff = Math.abs(endDate - now);

    let hours = Math.floor(diff / 3.6e6);
    let minutes = Math.floor((diff % 3.6e6) / 6e4);
    let seconds = Math.round(Math.floor((diff % 6e4) / 1000));
    let total;
    if (hours < 10) {
      if (minutes < 10) {
        if (seconds < 10) {
          total = "0" + hours + ":0" + minutes + ":0" + seconds;
        } else {
          total = "0" + hours + ":0" + minutes + ":" + seconds;
        }
      } else {
        if (seconds < 10) {
          total = "0" + hours + ":" + minutes + ":0" + seconds;
        } else {
          total = "0" + hours + ":" + minutes + ":" + seconds;
        }
      }
    } else {
      if (minutes < 10) {
        if (seconds < 10) {
          total = hours + ":0" + minutes + ":0" + seconds;
        } else {
          total = hours + ":0" + minutes + ":" + seconds;
        }
      } else {
        if (seconds < 10) {
          total = hours + ":" + minutes + ":0" + seconds;
        } else {
          total = hours + ":" + minutes + ":" + seconds;
        }
      }
    }

    setShiftLength(total);
  }

  const calculateshiftWithoutBreak = () => {
    let hours;
    let minutes;
    let seconds;

    const totalBreakHours = parseInt(totalBreak.slice(0, 2));
    const totalBreakMinutes = parseInt(totalBreak.slice(3, 5));
    const totalBreakSeconds = parseInt(totalBreak.slice(6, 8));

    const shiftLengthHours = parseInt(shiftLength.slice(0, 2));
    const shiftLengthMinutes = parseInt(shiftLength.slice(3, 5));
    const shiftLengthSeconds = parseInt(shiftLength.slice(6, 8));

    hours = shiftLengthHours - totalBreakHours;
    minutes = shiftLengthMinutes - totalBreakMinutes;
    seconds = shiftLengthSeconds - totalBreakSeconds;

    // Handle negative values
    if (seconds < 0) {
      minutes -= 1;
      seconds += 60;
    }
    if (minutes < 0) {
      hours -= 1;
      minutes += 60;
    }

    // Ensure that hours, minutes, and seconds are always two digits
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    const total = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    setShiftWOBreak(total);
  };

  useEffect(() => {
    calculateTotalBreak();
    calculateTotalShiftLength();
    calculateshiftWithoutBreak();
  }, [
    startvalue,
    endvalue,
    breakTime,
    shiftApproved,
    shiftLength,
    totalBreak,
    shiftWOBreak,
  ]);

  const handleStartDateChange = (date) => {
    setStartValue(date);
    calculateTotalShiftLength();
    calculateshiftWithoutBreak();
  };
  
  const handleEndDateChange = (date) => {
    setEndValue(date);
    calculateTotalShiftLength();
    calculateshiftWithoutBreak();
  };
  
  const deleteShift = (id) => {
    const config = {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${userInfo.JWT_TOKEN}`,
      },
    };
    axios
      .delete(
        `${process.env.REACT_APP_API_BACKEND}/api/employee/shiftdelete/${id}`,
        config
      )
      .then((res) => {
        props.setSuccess(res.data.message);
        props.fetchShifts();
        setOpenDelete(false);
        setOpen(false);
      })
      .catch((err) => {
        setOpen(false);
        console.log(err.response.data.message);
        props.setError(err.response.data.message);
      });
  };

  // Formatted content for schedule tooltip
  const scheduleContent = schedule ? (
    <Box
      sx={{
        fontSize: "0.85rem",
        color: "#fff",
        backdropFilter: "blur(2px)",
        borderRadius: "12px",
        padding: "15px",
        maxWidth: "300px",
        lineHeight: "1.5",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      <div><strong>Date:</strong> {new Date(schedule.date).toLocaleDateString()}</div>
      <div><strong>Day:</strong> {schedule.day}</div>
      <div><strong>Start Time:</strong> {schedule.startTime}</div>
      <div><strong>End Time:</strong> {schedule.endTime}</div>
      <div><strong>Total Hours:</strong> {schedule.totalHours}</div>
      <div><strong>Unpaid Break:</strong> {schedule.unpaidBreak}</div>
      <div><strong>Paid Break:</strong> {schedule.paidBreak}</div>
      <div><strong>Notes:</strong> {schedule.notes || "N/A"}</div>
      <div><strong>Total Shift Length:</strong> {schedule.totalShiftLength}</div>
    </Box>
  ) : null;

  return (
    <>
      <Box 
        sx={{ 
          border: `2px solid ${shiftApproved ? theme.palette.success.main : theme.palette.info.main}`, 
          width: isVerySmall ? "120px" : (isMobile ? "140px" : "160px"), 
          paddingBottom: "5px", 
          borderRadius: "15px", 
          display: "flex", 
          flexDirection: "column", 
          justifyContent: "space-between", 
          alignItems: "center", 
          textAlign: "center", 
          cursor: "pointer", 
          backgroundColor: theme.palette.background.paper, 
          transition: "background-color 0.3s ease", 
          margin: "auto", 
          marginTop: "5px",
          overflow: "hidden"
        }} onClick={handleClickOpen}>
        <Box sx={{
          fontWeight: "500",
          backgroundColor: shiftApproved ? theme.palette.success.main : theme.palette.info.main,
          color: theme.palette.text.secondary, 
          borderRadius: "10px", 
          width: "90%", 
          margin: "8px 2px 2px 2px", 
          textAlign: "center", 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}>
          <Box sx={{ 
            padding: "2px 0", 
            fontSize: isVerySmall ? "0.75rem" : "0.85rem", 
            fontWeight: "500" 
          }}>
            {formatTime(startTime).slice(0, 5)} -{" "}
            {endTime ? formatTime(endTime).slice(0, 5) : <span>Active</span>}
          </Box>
        </Box>
        <Box sx={{
          display: "flex", 
          flexDirection: isVerySmall ? "column" : "row",
          justifyContent: "space-between", 
          alignItems: "center",
          textAlign: "center",
          fontSize: isVerySmall ? "0.7rem" : "0.75rem",
          padding: "0",
          fontWeight: "400",
          width: "90%"
        }}>
          <Box sx={{ marginTop: "2px" }}>
            Shift:{" "} <span>{shiftLength && shiftLength.slice(0, 5)}</span>
          </Box>
          {!isVerySmall && (
            <Box sx={{ marginRight: "3px", marginLeft: "3px" }}>
              |
            </Box>
          )}
          <Box sx={{ marginTop: "2px" }}>
            Break: <span>{totalBreak && totalBreak.slice(0, 5)}</span>
          </Box>
        </Box>
        <Box sx={{ 
          fontSize: isVerySmall ? "0.7rem" : "0.75rem", 
          fontWeight: "400", 
          marginTop: "2px" 
        }}>
          W/o break:{" "}
          <span
            style={{ color: "#ee5622", fontWeight: "600" }}
          >{shiftWOBreak && shiftWOBreak.slice(0, 5)} </span>
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent style={{ padding: "0", display: "flex", flexDirection: "column" }}>
          {/* Header Section */}
          <Box sx={{
            padding: "15px 20px",
            backgroundColor: theme.palette.miscBg.bg,
            display: "flex",
            flexDirection: "column",
            borderRadius: "20px", 
            width: "100%"
          }}>
            <Box style={{ margin: "0 auto", marginTop: "10px" }}>
              <Avatar style={{
                width: "5rem", 
                height: "5rem", 
                fontWeight: "500", 
                fontSize: "2rem",
                borderRadius: "20%"
              }}>
                {getAvatarName(fullData)}
              </Avatar>
            </Box>
            
            <Link
              style={{ 
                textDecoration: "none", 
                color: theme.palette.text.primary, 
                margin: "5px auto"
              }}
              to={`/employee/${props.employeeId}`}
            >
              <Typography style={{ 
                fontWeight: "500", 
                textAlign: "center", 
                fontSize: "1.5rem", 
                textTransform: "capitalize"
              }}>
                {props.employee.fname} {props.employee.lname}
              </Typography>
            </Link>

            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px 10px",
              alignItems: "center",
              height: "max-content",
            }}>
              <Box sx={{
                display: "flex",
                flexDirection: "column"
              }}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <AccessTimeIcon sx={{marginRight: "2px"}}/> 
                  <span style={{ fontWeight: "600", textAlign: "center" }}>
                    {shiftLength.slice(0, 5)}
                  </span>
                </Box>
                <Box sx={{ fontSize: "0.8rem", textAlign: "center" }}>
                  Shift length
                </Box>
              </Box>
              
              <Box sx={{
                display: "flex",
                flexDirection: "column"
              }}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <FormatListBulletedIcon sx={{marginRight: "2px"}}/> 
                  <span style={{ fontWeight: "600", textAlign: "center" }}>
                    {totalBreak.slice(0, 5)}
                  </span>
                </Box>
                <Box sx={{ fontSize: "0.8rem", textAlign: "center" }}>
                  Total break
                </Box>
              </Box>
              
              <Box sx={{
                display: "flex",
                flexDirection: "column"
              }}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <TimelapseOutlined sx={{marginRight: "2px"}}/> 
                  <span style={{ fontWeight: "600", textAlign: "center", color: "#ee5622" }}>
                    {shiftWOBreak.slice(0, 5)}
                  </span>
                </Box>
                <Box sx={{ fontSize: "0.8rem", textAlign: "center" }}>
                  Shift w/o break
                </Box>
              </Box>
            </Box>
            
            {schedule && (
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                <Tooltip
                  title={<div>{scheduleContent}</div>}
                  arrow
                  placement="top"
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, 8],
                        },
                      },
                    ],
                  }}
                >
                  <Button
                    variant="contained"
                    style={{ 
                      backgroundColor: theme.palette.info.main,
                      color: theme.palette.text.secondary,
                      textTransform: "none",
                      fontWeight: "500",
                      padding: "5px 10px",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <CalendarIcon sx={{marginRight: "2px", fontSize: "1rem"}} />
                    Schedule
                  </Button>
                </Tooltip>
              </Box>
            )}
            
            {!props.shift.endDate && (
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                <Button 
                  variant="contained"
                  onClick={handleEndShift}
                  style={{ 
                    backgroundColor: "#ee5622", 
                    color: "#fff", 
                    fontWeight: "500",
                    textTransform: "none"
                  }}
                >
                  End Shift
                </Button>
              </Box>
            )}
          </Box>

          {/* Main Content */}
          <Box sx={{ padding: "15px", width: "100%" }}>
            <Typography sx={{ textAlign: "center", fontWeight: "600", fontSize: "1.2rem" }}>
              Edit Shift - {new Date(props.shift.startDate).toLocaleDateString()}
            </Typography>
            
            {!props.shift.endDate && (
              <Typography sx={{ color: "#ee5622", fontWeight: "500", textAlign: "center", fontSize: "0.9rem" }}>
                Currently Active
              </Typography>
            )}
            
            <Grid container spacing={1} sx={{ marginTop: "10px" }}>
              <Grid item xs={10} sx={{ margin: "0 auto 5px auto" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateTimePicker
                    ampm={false}
                    label="Start *"
                    sx={{ '& label': { color: theme.palette.text.primary } }}
                    value={startvalue}
                    slotProps={{ 
                      textField: { size: 'small', fullWidth: true },
                      toolbar: {
                        sx: {
                          '& .MuiTypography-root': {
                            color: theme.palette.text.primary
                          }
                        }
                      },
                      layout: {
                        sx: {
                          '& .MuiTabs-root': {
                            backgroundColor: theme.palette.background.default,
                          },
                          '& .MuiTab-root': {
                            color: theme.palette.text.primary,
                          },
                          '& .MuiClockNumber-root': {
                            color: theme.palette.text.primary
                          }
                        }
                      }
                    }}
                    format="dd/MM/yyyy HH:mm"
                    onChange={(newValue) => {
                      handleStartDateChange(newValue);
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={10} sx={{ margin: "5px auto 0 auto" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateTimePicker
                    ampm={false}
                    label="End *"
                    sx={{ '& label': { color: theme.palette.text.primary } }}
                    value={endvalue}
                    slotProps={{ 
                      textField: { size: 'small', fullWidth: true },
                      toolbar: {
                        sx: {
                          '& .MuiTypography-root': {
                            color: theme.palette.text.primary
                          }
                        }
                      },
                      layout: {
                        sx: {
                          '& .MuiTabs-root': {
                            backgroundColor: theme.palette.background.default,
                          },
                          '& .MuiTab-root': {
                            color: theme.palette.text.primary,
                          },
                          '& .MuiClockNumber-root': {
                            color: theme.palette.text.primary
                          }
                        }
                      }
                    }}
                    format="dd/MM/yyyy HH:mm"
                    onChange={(newValue) => {
                      handleEndDateChange(newValue);
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>

            {/* Shift Images */}
            <Grid container spacing={2} sx={{ marginTop: "10px" }}>
              <Grid item xs={6}>
                {props.shift.startImage && (
                  <img
                    src={convertS3ToCloudFront(props.shift.startImage)}
                    alt="Start Shift Image"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.divider}`
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                {props.shift.endImage && (
                  <img
                    src={convertS3ToCloudFront(props.shift.endImage)}
                    alt="End Shift Image"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.divider}`
                    }}
                  />
                )}
              </Grid>
            </Grid>
            
            {/* Breaks Section */}
            <Box sx={{ marginTop: "15px" }}>
              <Typography variant="subtitle1" sx={{ fontWeight: "500" }}>Breaks</Typography>
              {breakTime.length === 0 ? (
                <Typography sx={{ fontStyle: "italic", color: theme.palette.text.primary, fontSize: "0.9rem" }}>
                  No breaks recorded
                </Typography>
              ) : (
                breakTime.map((brk, index) => (
                  <Grid container spacing={2} key={index} sx={{ marginTop: '8px' }}>
                    <Grid item xs={5}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          label="From"
                          value={new Date(brk.start)}
                          ampm={false}
                          slotProps={{ textField: { size: 'small', fullWidth: true } }}
                          sx={{ '& label': { color: theme.palette.text.primary } }}
                          onChange={(newValue) => {
                            updateStartBreak(newValue, index);
                            calculateTotalBreak();
                            calculateshiftWithoutBreak();
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={5}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          label="To"
                          value={new Date(brk.end)}
                          ampm={false}
                          slotProps={{ textField: { size: 'small', fullWidth: true } }}
                          sx={{ '& label': { color: theme.palette.text.primary } }}
                          onChange={(newValue) => {
                            updateEndBreak(newValue, index);
                            calculateTotalBreak();
                            calculateshiftWithoutBreak();
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3} sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}>
                      <Typography sx={{ fontWeight: "500", fontSize: "0.9rem" }}>
                        {calculateBreakLength(brk.start, brk.end ? brk.end : new Date()).slice(1)}
                      </Typography>
                      <RemoveCircleOutlineIcon 
                        sx={{ color: "red", cursor: "pointer" }} 
                        onClick={() => removeBreak(index)}
                      />
                    </Grid>
                  </Grid>
                ))
              )}
              
              <Button
                variant="contained"
                sx={{
                  marginTop: "10px",
                  textTransform: "none",
                  backgroundColor: theme.palette.info.main,
                  fontWeight: "500",
                }}
                onClick={addBreak}
                startIcon={<AddIcon />}
              >
                Add Break
              </Button>
            </Box>
            
            {/* Shift Approval and Timeline */}
            <Box sx={{ 
              marginTop: "15px", 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "flex-start" 
            }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  checked={shiftApproved}
                  sx={{ paddingLeft: "0", color: theme.palette.text.primary }}
                  onChange={handleShiftApproved}
                />
                <Typography>Shift Approved</Typography>
              </Box>
              <ShiftTimeLine shiftTimelines={props.shift.shiftTimelines} />
            </Box>
            
            {/* Buttons */}
            <Box sx={{
              marginTop: "15px",
              display: "flex",
              justifyContent: "space-between",
            }}>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  backgroundColor: theme.palette.error.main,
                  color: theme.palette.text.secondary,
                }}
                onClick={() => setOpenDelete(true)}
                startIcon={<DeleteForeverOutlined />}
              >
                Delete
              </Button>
              
              <Box>
                <Button
                  variant="contained"
                  sx={{ 
                    textTransform: "none", 
                    backgroundColor: theme.palette.primary.main,
                    marginRight: "5px",
                  }}
                  startIcon={<DoneIcon />}
                  onClick={submitHandler}
                >
                  Update
                </Button>

                {!shiftApproved && (
                  <Button
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      backgroundColor: theme.palette.success.main,
                      color: theme.palette.text.secondary,
                      fontWeight: "500",
                    }}
                    onClick={approveAndUpdate}
                    startIcon={<DoneIcon />}
                  >
                    Approve
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
      >
        <DialogTitle>Delete Shift?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this shift?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={() => deleteShift(props.shift.id)} 
            color="primary" 
            variant="contained"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}